import { BookAnimation } from 'core/display/spines/BookAnimation'

export default class BookAnimationContainer extends PIXI.Container {
  constructor(data) {
    super()
    this.addChild(new BookAnimation(data))
  }
}
